import React from 'react';
const Schedule = () => {
  return (
    <h2>Schedule</h2>
  );
}

export default Schedule;